import React from 'react';
import { ImageFile } from '~/data/types/images';

const linkIconIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_897_3403)">
        <path
          d="M10.115 13.5062L7.30987 16.3113C7.30987 16.3113 7.30987 16.3114 7.30981 16.3114C7.30981 16.3114 7.30981 16.3114 7.30974 16.3114C6.14975 17.4715 4.2622 17.4716 3.10208 16.3114C2.54007 15.7494 2.23063 15.0022 2.23063 14.2075C2.23063 13.4129 2.54007 12.6658 3.10188 12.1038C3.10194 12.1038 3.10201 12.1037 3.10208 12.1036L5.90716 9.29849C6.29442 8.91117 6.29442 8.28317 5.9071 7.89591C5.51984 7.50865 4.89184 7.50865 4.50452 7.89591L1.69943 10.7011C1.69924 10.7013 1.69904 10.7015 1.69884 10.7017C0.762664 11.6382 0.24707 12.8833 0.24707 14.2075C0.24707 15.5321 0.762862 16.7774 1.6995 17.714C2.66629 18.6807 3.9361 19.1641 5.20597 19.1641C6.47585 19.1641 7.74573 18.6807 8.71238 17.714V17.7139C8.71245 17.7139 8.71245 17.7139 8.71245 17.7139L11.5175 14.9087C11.9048 14.5215 11.9048 13.8935 11.5175 13.5062C11.1303 13.1189 10.5023 13.1189 10.115 13.5062Z"
          fill="black"
        />
        <path
          d="M18.5807 5.79247C18.5807 4.46791 18.0648 3.22263 17.1282 2.286C15.1947 0.352552 12.0487 0.352618 10.1153 2.286C10.1152 2.28613 10.1151 2.28619 10.115 2.28633L7.31002 5.09128C6.9227 5.47854 6.9227 6.1066 7.31002 6.49386C7.50375 6.68758 7.75752 6.78438 8.01135 6.78438C8.26511 6.78438 8.519 6.68752 8.7126 6.49386L11.5176 3.6889C11.5177 3.68877 11.5178 3.6887 11.518 3.68857C12.6779 2.52858 14.5655 2.52852 15.7256 3.68857C16.2876 4.25058 16.5971 4.99779 16.5971 5.79247C16.5971 6.58708 16.2877 7.33416 15.7258 7.89617C15.7257 7.89623 15.7257 7.8963 15.7256 7.89637L12.9205 10.7015C12.5333 11.0888 12.5333 11.7168 12.9206 12.1041C13.1143 12.2978 13.3681 12.3946 13.6218 12.3946C13.8757 12.3946 14.1295 12.2978 14.3232 12.1041L17.1283 9.29894C17.1285 9.29875 17.1287 9.29848 17.1289 9.29828C18.065 8.36178 18.5807 7.11669 18.5807 5.79247Z"
          fill="black"
        />
        <path
          d="M5.90768 13.5064C6.10134 13.7001 6.35517 13.797 6.60893 13.797C6.86276 13.797 7.11659 13.7001 7.31026 13.5064L12.9206 7.89614C13.3079 7.50889 13.3079 6.88089 12.9206 6.49357C12.5333 6.10631 11.9053 6.10631 11.518 6.49357L5.90768 12.1038C5.52036 12.4912 5.52036 13.1192 5.90768 13.5064Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_897_3403">
          <rect
            width="18.3333"
            height="18.3333"
            fill="white"
            transform="translate(0.24707 0.833984)"
          />
        </clipPath>
      </defs>
    </Component>
  );
};

export default linkIconIcon;
